import { SvgIcon, SvgIconProps, useTheme } from '@mui/material';

interface WorkExperienceIconIconProps extends SvgIconProps {
  active?: boolean;
}

const WorkExperienceIcon = ({
  active,
  width = 28,
  height = 28,
  stroke,
  sx: _sx,
  ...rest
}: WorkExperienceIconIconProps) => {
  const theme = useTheme();

  const color = active
    ? theme.palette.button.primary
    : theme.palette.text.secondary;

  return (
    <SvgIcon
      sx={{ width, height, fill: 'none' }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28 28"
      {...rest}
    >
      <path
        d="M10.4999 5.83325H5.83325L5.83325 24.5L22.1666 24.4999V5.83325L17.4999 5.83325"
        stroke={stroke ?? color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M17.5 3.5H10.5V8.16667H17.5V3.5Z"
        stroke={stroke ?? color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10.5 19.8333V14"
        stroke={stroke ?? color}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M14 19.8334V18.6667"
        stroke={stroke ?? color}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 19.8333V16.3333"
        stroke={stroke ?? color}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default WorkExperienceIcon;
